import { render } from "./insure-report-detail.vue?vue&type=template&id=06d81d89&scoped=true&ts=true"
import script from "./insure-report-detail.vue?vue&type=script&lang=ts"
export * from "./insure-report-detail.vue?vue&type=script&lang=ts"

import "./insure-report-detail.vue?vue&type=style&index=0&id=06d81d89&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d81d89"]])

export default __exports__